import { render } from "./PostsBlock.vue?vue&type=template&id=183558f9&scoped=true"
import script from "./PostsBlock.vue?vue&type=script&lang=js"
export * from "./PostsBlock.vue?vue&type=script&lang=js"

import "./PostsBlock.vue?vue&type=style&index=0&id=183558f9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183558f9"]])

export default __exports__